<template>
  <v-dialog v-model="show" width="auto" persistent>
    <v-card class="pa-6" elevation="10" rounded="xl">
      <v-card-text class="text-center">
        <v-icon size="100" color="orange lighten-2" class="mb-4">
          mdi-alert-circle-outline
        </v-icon>
        <div class="headline font-weight-bold mb-2">¡ALERTA!</div>
        <div class="body-1 mb-6">
          A partir de este momento sales de dominio IEL<br />
          y entras al sitio de CFE.
        </div>
        <div class="d-flex justify-center">
          <v-btn
            class="white--text rounded-pill button-green-round mr-1"
            @click="hide"
          >
            CANCELAR
          </v-btn>

          <v-btn
            class="white--text rounded-pill button-red-round"
            href="https://lapem.cfe.gob.mx/sigla03v2/#/login"
          >
            CONTINUAR
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    name: 'TestCFENoticeAlert',

    computed: {
      ...mapState('testNoticesCFEAlert', {
        visible: (state) => state.visible,
      }),

      show: {
        set(val) {
          if (!val) {
            this.hide();
          }
        },
        get() {
          return this.visible;
        },
      },
    },
    methods: {
      ...mapActions('testNoticesCFEAlert', ['hide']),
    },
  };
</script>
